Whether this advertisement product should be preselected or not.

This field generally indicates the advertisement product that is set in the current state of an existing `PositionProfile`.
